import {NinchatProperties} from '../../api/types'
import React from 'react'
import Tag from '../Tag'
import {
    TagProps,
} from '../Tag/types'
import {mapTags} from '../../utils/MapTags'
import {styled} from '../../stitches/config'

interface SendStatusProps {
    tags: {
        [key: NinchatProperties.TagID]: NinchatProperties.NinchatTag,
    }
    tagIds: NinchatProperties.TagID[]
}

interface Tags {
    [key: NinchatProperties.TagID]: TagProps;
}

interface SendStatusStateProps {
    tags: Tags;
}

const StyledTags = styled('div', {
    display: 'inline-flex',
    marginLeft: '0.4rem',
})

const SendStatusView: React.FC<SendStatusProps> = (props: SendStatusProps): React.ReactElement => {
    const {
        tags,
        tagIds,
    } = props

    const defaultSendStatusState: SendStatusStateProps = {tags: {}}

    const [sendStatusState, setSendStatusState] = React.useState(defaultSendStatusState)

    React.useEffect(() => {
        const filteredTags = mapTags({
            tagIds,
            tags,
        })

        const newSendStatusState: SendStatusStateProps = {
            ...sendStatusState,
            tags: filteredTags,
        }

        setSendStatusState(newSendStatusState)
    }, [tags, tagIds])

    return (
        <div>
            {Object.keys(sendStatusState.tags).map((tag_id) => (
                <StyledTags key={tag_id}>
                    <Tag
                        showParent={true}
                        showTheme={false}
                        {...{
                            ...sendStatusState.tags[tag_id],
                            selected: false,
                        }}
                    />
                </StyledTags>
            ))}
        </div>
    )
}

export default SendStatusView
